var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLongformH2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 10,
  viewBox: "0 0 18 10",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M.013 9.858h4.03v-.736l-1.13-.235V5.459H7.16v3.434l-1.13.235v.73h4.088v-.73l-1.136-.241V.984l1.073-.127V0H6.1v.857l1.06.12v3.466H2.914V.983L3.98.858V0H0v.857L1.085.99v7.89l-1.072.242zm11.508 0h6.075l.425-1.923-.755-.235-.597.812-3.466.375c2.533-1.613 4.05-3.073 4.05-4.824 0-1.137-.959-2.222-2.793-2.222-1.587 0-2.85.87-3.218 1.384l.438.672c.457-.38 1.244-.92 2.202-.92 1.06 0 1.492.825 1.492 1.555 0 1.505-2.044 3.377-4.113 4.64z"
})));
export default SvgLongformH2;